/**
 * Seanse uvezene iz WordPressa (`migration/run.ts`, `migration/delta.ts`) nemaju
 * kolonu ni mapiranje koje ih označava; jedini pouzdan znak je prefiks bilješke koji
 * oba uvoza upisuju. Isti znak već koristi i gašenje podsjetnika za migrirane
 * prošle termine, pa se ovdje drži na jednom mjestu.
 *
 * Čist modul (bez baze), jer ga koristi i admin prikaz razlaganja u klijentskom bundleu.
 */
export const MIGRATED_SESSION_NOTES_PREFIX = "Migrirano iz WP";

/** SQL uslov "seansa je migrirana iz WP", za kolonu bilješke sa zadanim aliasom. */
export function migratedSessionSql(notesColumn = "notes"): string {
  return `COALESCE(${notesColumn}, '') LIKE '${MIGRATED_SESSION_NOTES_PREFIX}%'`;
}

export function isMigratedSessionNotes(notes: string | null | undefined): boolean {
  return typeof notes === "string" && notes.startsWith(MIGRATED_SESSION_NOTES_PREFIX);
}
